/* ==== Plik: assets/theme.js ==== */
// Główne skrypty JavaScript dla motywu @Miko Kawaii

document.addEventListener('DOMContentLoaded', function() {
    // --- Obsługa menu mobilnego ---
    const mobileMenuButtonPro = document.getElementById('mobile-menu-button-pro');
    const mobileMenuPro = document.getElementById('mobile-menu-pro');

    if (mobileMenuButtonPro && mobileMenuPro) {
        mobileMenuButtonPro.addEventListener('click', () => {
            const isExpanded = mobileMenuButtonPro.getAttribute('aria-expanded') === 'true' || false;
            mobileMenuButtonPro.setAttribute('aria-expanded', !isExpanded);
            mobileMenuPro.classList.toggle('hidden');
            // Opcjonalnie: dodaj/usuń klasę 'is-active' do przycisku dla stylizacji (np. zmiana ikony hamburgera na X)
            // mobileMenuButtonPro.classList.toggle('is-active');
        });
    }

    // --- Aktualizacja roku w stopce ---
    const currentYearElementProFooter = document.getElementById('currentYearProFooter');
    if (currentYearElementProFooter) {
        currentYearElementProFooter.textContent = new Date().getFullYear();
    }
    // Możesz dodać podobny kod dla innych ID, jeśli rok jest wyświetlany w wielu miejscach
    // const currentYearElementAnother = document.getElementById('currentYearAnother');
    // if (currentYearElementAnother) {
    //     currentYearElementAnother.textContent = new Date().getFullYear();
    // }

    // --- Animacja "fade in up" dla elementów przy scrollowaniu ---
    const animatedElements = document.querySelectorAll('.fade-in-up');
    if (animatedElements.length > 0 && typeof IntersectionObserver !== 'undefined') {
        const observer = new IntersectionObserver((entries, obs) => { // Dodano 'obs' do argumentów
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    // Upewnij się, że animacja ma zdefiniowaną nazwę i czas trwania w CSS
                    // lub ustaw je tutaj, jeśli to konieczne.
                    // entry.target.style.animationName = 'fadeInUp';
                    // entry.target.style.animationDuration = '0.8s';
                    entry.target.style.animationPlayState = 'running';
                    obs.unobserve(entry.target); // Animacja odpali się tylko raz
                }
            });
        }, { threshold: 0.1 }); // Odpal animację, gdy 10% elementu jest widoczne

        animatedElements.forEach(el => {
            // Upewnij się, że animacja jest początkowo wstrzymana.
            // Jeśli 'animation-play-state: paused;' jest ustawione w CSS, ten krok nie jest konieczny.
            // Jeśli nie, możesz to ustawić tutaj:
            // el.style.animationPlayState = 'paused';
            observer.observe(el);
        });
    } else if (animatedElements.length > 0) {
        // Fallback dla starszych przeglądarek bez IntersectionObserver - po prostu pokaż elementy
        animatedElements.forEach(el => {
            el.style.opacity = '1';
            el.style.transform = 'translateY(0)';
        });
    }

    // Komunikat w konsoli dla dewelopera
    console.log("%c🐾 @Miko Kawaii Theme JS Loaded! ✨", "color: #E91E63; font-family: Pacifico; font-size: 1.2rem;");

    // Tutaj możesz dodać więcej specyficznych dla motywu skryptów JS,
    // np. obsługa karuzel, niestandardowych dropdownów, zaawansowanej walidacji formularzy itp.
});
